export default {
  indexYear: "2027",
  wageDateSeries: "7/1/2026 - 6/30/2027",
  country: [
    "UNITED STATES OF AMERICA",
    "AFGHANISTAN",
    "ALBANIA",
    "ALGERIA",
    "ANDORRA",
    "ANGOLA",
    "ANGUILLA",
    "ANTIGUA AND BARBUDA",
    "ARGENTINA",
    "ARMENIA",
    "AUSTRALIA",
    "AUSTRIA",
    "AZERBAIJAN",
    "BAHAMAS",
    "BAHRAIN",
    "BANGLADESH",
    "BARBADOS",
    "BELARUS",
    "BELGIUM",
    "BELIZE",
    "BENIN",
    "BERMUDA",
    "BHUTAN",
    "BOLIVIA",
    "BOSNIA AND HERZEGOVINA",
    "BOTSWANA",
    "BRAZIL",
    "BRITISH VIRGIN ISLANDS",
    "BRUNEI",
    "BULGARIA",
    "BURKINA FASO",
    "BURMA (MYANMAR)",
    "BURUNDI",
    "CABO VERDE",
    "CAMBODIA",
    "CAMEROON",
    "CANADA",
    "CAPE VERDE",
    "CAYMAN ISLANDS",
    "CENTRAL AFRICAN REPUBLIC",
    "CHAD",
    "CHILE",
    "CHINA",
    "COLOMBIA",
    "COMOROS",
    "COSTA RICA",
    "CROATIA",
    "CUBA",
    "CYPRUS",
    "CZECH REPUBLIC",
    "CZECHIA",
    "CZECHOSLOVAKIA",
    "CÔTE D’IVOIRE",
    "DEMOCRATIC REPUBLIC OF THE CONGO",
    "DENMARK",
    "DJIBOUTI",
    "DOMINICA",
    "DOMINICAN REPUBLIC",
    "EAST TIMOR",
    "ECUADOR",
    "EGYPT",
    "EL SALVADOR",
    "EQUATORIAL GUINEA",
    "ERITREA",
    "ESTONIA",
    "ESWATINI",
    "ETHIOPIA",
    "FIJI",
    "FINLAND",
    "FRANCE",
    "GABON",
    "GAMBIA",
    "GEORGIA",
    "GERMANY",
    "GHANA",
    "GIBRALTAR",
    "GREECE",
    "GREENLAND",
    "GRENADA",
    "GUATEMALA",
    "GUINEA",
    "GUINEA-BISSAU",
    "GUYANA",
    "HAITI",
    "HOLY SEE",
    "HONDURAS",
    "HONG KONG",
    "HUNGARY",
    "ICELAND",
    "INDIA",
    "INDONESIA",
    "IRAN",
    "IRAQ",
    "IRELAND",
    "ISRAEL",
    "ITALY",
    "IVORY COAST",
    "JAMAICA",
    "JAPAN",
    "JORDAN",
    "KAZAKHSTAN",
    "KENYA",
    "KIRIBATI",
    "KOSOVO",
    "KUWAIT",
    "KYRGYZSTAN",
    "LAOS",
    "LATVIA",
    "LEBANON",
    "LESOTHO",
    "LIBERIA",
    "LIBYA",
    "LIECHTENSTEIN",
    "LITHUANIA",
    "LUXEMBOURG",
    "MACEDONIA",
    "MADAGASCAR",
    "MALAWI",
    "MALAYSIA",
    "MALDIVES",
    "MALI",
    "MALTA",
    //"MARSHALL ISLANDS",
    "MAURITANIA",
    "MAURITIUS",
    "MEXICO",
    "MICRONESIA",
    "MOLDOVA",
    "MONACO",
    "MONGOLIA",
    "MONTENEGRO",
    "MOROCCO",
    "MOZAMBIQUE",
    "NAMIBIA",
    "NAURU",
    "NEPAL",
    "NETHERLANDS",
    "NEW ZEALAND",
    "NICARAGUA",
    "NIGER",
    "NIGERIA",
    "NORTH KOREA",
    "NORTH MACEDONIA",
    "NORTHERN CYPRUS",
    "NORWAY",
    "OMAN",
    "PAKISTAN",
    //"PALAU",
    "PALESTINE",
    "PANAMA",
    "PAPUA NEW GUINEA",
    "PARAGUAY",
    "PERU",
    "PHILIPPINES",
    "POLAND",
    "PORTUGAL",
    "QATAR",
    "REPUBLIC OF CONGO",
    "ROMANIA",
    "RUSSIA",
    "RWANDA",
    "SAINT KITTS AND NEVIS",
    "SAINT LUCIA",
    "SAINT VINCENT AND THE GRENADINES",
    "SAMOA",
    "SAN MARINO",
    "SAO TOME AND PRINCIPE",
    "SAUDI ARABIA",
    "SENEGAL",
    "SERBIA",
    "SEYCHELLES",
    "SIERRA LEONE",
    "SINGAPORE",
    "SLOVAKIA",
    "SLOVENIA",
    "SOLOMON ISLANDS",
    "SOMALIA",
    "SOMALILAND",
    "SOUTH AFRICA",
    "SOUTH KOREA",
    "SOUTH OSSETIA",
    "SOUTH SUDAN",
    "SPAIN",
    "SRI LANKA",
    "SUDAN",
    "SURINAME",
    "SWAZILAND",
    "SWEDEN",
    "SWITZERLAND",
    "SYRIA",
    "TAIWAN",
    "TAJIKISTAN",
    "TANZANIA",
    "THAILAND",
    "THE BAHAMAS",
    "TIMOR-LESTE",
    "TOGO",
    "TONGA",
    "TRANSNISTRIA",
    "TRINIDAD AND TOBAGO",
    "TUNISIA",
    "TURKEY",
    "TURKMENISTAN",
    "TUVALU",
    "UGANDA",
    "UKRAINE",
    "UNITED ARAB EMIRATES",
    "UNITED KINGDOM",
    "URUGUAY",
    "UZBEKISTAN",
    "VANUATU",
    "VATICAN CITY",
    "VENEZUELA",
    "VIETNAM",
    "YEMEN",
    "ZAMBIA",
    "ZIMBABWE",
  ],
  // newCountry: [
  //   "UNITED STATES OF AMERICA",
  //   "AFGHANISTAN",
  //   "ALBANIA",
  //   "ALGERIA",
  //   "ANDORRA",
  //   "ANGOLA",
  //   "ANTIGUA AND BARBUDA",
  //   "ARGENTINA",
  //   "ARMENIA",
  //   "AUSTRALIA",
  //   "AUSTRIA",
  //   "AZERBAIJAN",
  //   "BAHRAIN",
  //   "BANGLADESH",
  //   "BARBADOS",
  //   "BELARUS",
  //   "BELGIUM",
  //   "BELIZE",
  //   "BENIN",
  //   "BHUTAN",
  //   "BOLIVIA",
  //   "BOSNIA AND HERZEGOVINA",
  //   "BOTSWANA",
  //   "BRAZIL",
  //   "BRUNEI",
  //   "BULGARIA",
  //   "BURKINA FASO",
  //   "BURMA",
  //   "BURUNDI",
  //   "CABO VERDE",
  //   "CAMBODIA",
  //   "CAMEROON",
  //   "CANADA",
  //   "CENTRAL AFRICAN REPUBLIC",
  //   "CHAD",
  //   "CHILE",
  //   "CHINA",
  //   "COLOMBIA",
  //   "COMOROS",
  //   "COSTA RICA",
  //   "CROATIA",
  //   "CUBA",
  //   "CYPRUS",
  //   "CZECHIA",
  //   "CÔTE D’IVOIRE",
  //   "DEMOCRATIC REPUBLIC OF THE CONGO",
  //   "DENMARK",
  //   "DJIBOUTI",
  //   "DOMINICA",
  //   "DOMINICAN REPUBLIC",
  //   "ECUADOR",
  //   "EGYPT",
  //   "EL SALVADOR",
  //   "EQUATORIAL GUINEA",
  //   "ERITREA",
  //   "ESTONIA",
  //   "ESWATINI",
  //   "ETHIOPIA",
  //   "FIJI",
  //   "FINLAND",
  //   "FRANCE",
  //   "GABON",
  //   "GEORGIA",
  //   "GERMANY",
  //   "GHANA",
  //   "GREECE",
  //   "GRENADA",
  //   "GUATEMALA",
  //   "GUINEA",
  //   "GUINEA-BISSAU",
  //   "GUYANA",
  //   "HAITI",
  //   "HOLY SEE",
  //   "HONDURAS",
  //   "HUNGARY",
  //   "ICELAND",
  //   "INDIA",
  //   "INDONESIA",
  //   "IRAN",
  //   "IRAQ",
  //   "IRELAND",
  //   "ISRAEL",
  //   "ITALY",
  //   "JAMAICA",
  //   "JAPAN",
  //   "JORDAN",
  //   "KAZAKHSTAN",
  //   "KENYA",
  //   "KIRIBATI",
  //   "KOSOVO",
  //   "KUWAIT",
  //   "KYRGYZSTAN",
  //   "LAOS",
  //   "LATVIA",
  //   "LEBANON",
  //   "LESOTHO",
  //   "LIBERIA",
  //   "LIBYA",
  //   "LIECHTENSTEIN",
  //   "LITHUANIA",
  //   "LUXEMBOURG",
  //   "MADAGASCAR",
  //   "MALAWI",
  //   "MALAYSIA",
  //   "MALDIVES",
  //   "MALI",
  //   "MALTA",
  //   "MARSHALL ISLANDS",
  //   "MAURITANIA",
  //   "MAURITIUS",
  //   "MEXICO",
  //   "MICRONESIA",
  //   "MOLDOVA",
  //   "MONACO",
  //   "MONGOLIA",
  //   "MONTENEGRO",
  //   "MOROCCO",
  //   "MOZAMBIQUE",
  //   "NAMIBIA",
  //   "NAURU",
  //   "NEPAL",
  //   "NETHERLANDS",
  //   "NEW ZEALAND",
  //   "NICARAGUA",
  //   "NIGER",
  //   "NIGERIA",
  //   "NORTH KOREA",
  //   "NORTH MACEDONIA",
  //   "NORWAY",
  //   "OMAN",
  //   "PAKISTAN",
  //   "PALAU",
  //   "PALESTINIAN TERRITORIES",
  //   "PANAMA",
  //   "PAPUA NEW GUINEA",
  //   "PARAGUAY",
  //   "PERU",
  //   "PHILIPPINES",
  //   "POLAND",
  //   "PORTUGAL",
  //   "QATAR",
  //   "REPUBLIC OF THE CONGO",
  //   "ROMANIA",
  //   "RUSSIA",
  //   "RWANDA",
  //   "SAINT KITTS AND NEVIS",
  //   "SAINT LUCIA",
  //   "SAINT VINCENT AND THE GRENADINES",
  //   "SAMOA",
  //   "SAN MARINO",
  //   "SAO TOME AND PRINCIPE",
  //   "SAUDI ARABIA",
  //   "SENEGAL",
  //   "SERBIA",
  //   "SEYCHELLES",
  //   "SIERRA LEONE",
  //   "SINGAPORE",
  //   "SLOVAKIA",
  //   "SLOVENIA",
  //   "SOLOMON ISLANDS",
  //   "SOMALIA",
  //   "SOUTH AFRICA",
  //   "SOUTH KOREA",
  //   "SOUTH SUDAN",
  //   "SPAIN",
  //   "SRI LANKA",
  //   "SUDAN",
  //   "SURINAME",
  //   "SWEDEN",
  //   "SWITZERLAND",
  //   "SYRIA",
  //   "TAIWAN",
  //   "TAJIKISTAN",
  //   "TANZANIA",
  //   "THAILAND",
  //   "THE BAHAMAS",
  //   "TIMOR-LESTE",
  //   "TOGO",
  //   "TONGA",
  //   "TRINIDAD AND TOBAGO",
  //   "TUNISIA",
  //   "TURKEY (TÜRKIYE)",
  //   "TURKMENISTAN",
  //   "TUVALU",
  //   "UGANDA",
  //   "UKRAINE",
  //   "UNITED ARAB EMIRATES",
  //   "UNITED KINGDOM",
  //   "URUGUAY",
  //   "UZBEKISTAN",
  //   "VANUATU",
  //   "VENEZUELA",
  //   "VIETNAM",
  //   "YEMEN",
  //   "ZAMBIA",
  //   "ZIMBABWE",
  // ],
  // oldCountry: [
  //   "UNITED STATES OF AMERICA",
  //   "AFGHANISTAN",
  //   "ALBANIA",
  //   "ALGERIA",
  //   "ANDORRA",
  //   "ANGOLA",
  //   "ANGUILLA",
  //   "ANTIGUA AND BARBUDA",
  //   "ARGENTINA",
  //   "ARMENIA",
  //   "AUSTRALIA",
  //   "AUSTRIA",
  //   "AZERBAIJAN",
  //   "BAHAMAS",
  //   "BAHRAIN",
  //   "BANGLADESH",
  //   "BARBADOS",
  //   "BELARUS",
  //   "BELGIUM",
  //   "BELIZE",
  //   "BENIN",
  //   "BERMUDA",
  //   "BHUTAN",
  //   "BOLIVIA",
  //   "BOSNIA AND HERZEGOVINA",
  //   "BOTSWANA",
  //   "BRAZIL",
  //   "BRITISH VIRGIN ISLANDS",
  //   "BRUNEI",
  //   "BULGARIA",
  //   "BURKINA FASO",
  //   "BURMA (MYANMAR)",
  //   "BURUNDI",
  //   "CAMBODIA",
  //   "CAMEROON",
  //   "CANADA",
  //   "CAPE VERDE",
  //   "CAYMAN ISLANDS",
  //   "CENTRAL AFRICAN REPUBLIC",
  //   "CHAD",
  //   "CHILE",
  //   "CHINA",
  //   "COLOMBIA",
  //   "COMOROS",
  //   "COSTA RICA",
  //   "CROATIA",
  //   "CUBA",
  //   "CYPRUS",
  //   "CZECH REPUBLIC",
  //   "DEMOCRATIC REPUBLIC OF THE CONGO",
  //   "DENMARK",
  //   "DJIBOUTI",
  //   "DOMINICA",
  //   "DOMINICAN REPUBLIC",
  //   "EAST TIMOR",
  //   "ECUADOR",
  //   "EGYPT",
  //   "EL SALVADOR",
  //   "EQUATORIAL GUINEA",
  //   "ERITREA",
  //   "ESTONIA",
  //   "ETHIOPIA",
  //   "FIJI",
  //   "FINLAND",
  //   "FRANCE",
  //   "GABON",
  //   "GAMBIA",
  //   "GEORGIA",
  //   "GERMANY",
  //   "GHANA",
  //   "GIBRALTAR",
  //   "GREECE",
  //   "GREENLAND",
  //   "GRENADA",
  //   "GUATEMALA",
  //   "GUINEA",
  //   "GUINEA-BISSAU",
  //   "GUYANA",
  //   "HAITI",
  //   "HONDURAS",
  //   "HONG KONG",
  //   "HUNGARY",
  //   "ICELAND",
  //   "INDIA",
  //   "INDONESIA",
  //   "IRAN",
  //   "IRAQ",
  //   "IRELAND",
  //   "ISRAEL",
  //   "ITALY",
  //   "IVORY COAST",
  //   "JAMAICA",
  //   "JAPAN",
  //   "JORDAN",
  //   "KAZAKHSTAN",
  //   "KENYA",
  //   "KIRIBATI",
  //   "KOSOVO",
  //   "KUWAIT",
  //   "KYRGYZSTAN",
  //   "LAOS",
  //   "LATVIA",
  //   "LEBANON",
  //   "LESOTHO",
  //   "LIBERIA",
  //   "LIBYA",
  //   "LIECHTENSTEIN",
  //   "LITHUANIA",
  //   "LUXEMBOURG",
  //   "MACEDONIA",
  //   "MADAGASCAR",
  //   "MALAWI",
  //   "MALAYSIA",
  //   "MALDIVES",
  //   "MALI",
  //   "MALTA",
  //   "MARSHALL ISLANDS",
  //   "MAURITANIA",
  //   "MAURITIUS",
  //   "MEXICO",
  //   "MOLDOVA",
  //   "MONACO",
  //   "MONGOLIA",
  //   "MOROCCO",
  //   "MOZAMBIQUE",
  //   "NAMIBIA",
  //   "NAURU",
  //   "NEPAL",
  //   "NETHERLANDS",
  //   "NEW ZEALAND",
  //   "NICARAGUA",
  //   "NIGER",
  //   "NIGERIA",
  //   "NORTH KOREA",
  //   "NORTHERN CYPRUS",
  //   "NORWAY",
  //   "OMAN",
  //   "PAKISTAN",
  //   "PALAU",
  //   "PALESTINE",
  //   "PANAMA",
  //   "PAPUA NEW GUINEA",
  //   "PARAGUAY",
  //   "PERU",
  //   "PHILIPPINES",
  //   "POLAND",
  //   "PORTUGAL",
  //   "QATAR",
  //   "REPUBLIC OF CONGO",
  //   "ROMANIA",
  //   "RUSSIA",
  //   "RWANDA",
  //   "SAINT KITTS AND NEVIS",
  //   "SAINT LUCIA",
  //   "SAINT VINCENT AND THE GRENADINES",
  //   "SAMOA",
  //   "SAN MARINO",
  //   "SAO TOME AND PRINCIPE",
  //   "SAUDI ARABIA",
  //   "SENEGAL",
  //   "SERBIA",
  //   "SEYCHELLES",
  //   "SIERRA LEONE",
  //   "SINGAPORE",
  //   "SLOVAKIA",
  //   "SLOVENIA",
  //   "SOLOMON ISLANDS",
  //   "SOMALIA",
  //   "SOMALILAND",
  //   "SOUTH AFRICA",
  //   "SOUTH KOREA",
  //   "SOUTH OSSETIA",
  //   "SPAIN",
  //   "SRI LANKA",
  //   "SUDAN",
  //   "SURINAME",
  //   "SWAZILAND",
  //   "SWEDEN",
  //   "SWITZERLAND",
  //   "SYRIA",
  //   "TAIWAN",
  //   "TAJIKISTAN",
  //   "TANZANIA",
  //   "THAILAND",
  //   "TOGO",
  //   "TONGA",
  //   "TRANSNISTRIA",
  //   "TRINIDAD AND TOBAGO",
  //   "TUNISIA",
  //   "TURKEY",
  //   "TURKMENISTAN",
  //   "TUVALU",
  //   "UGANDA",
  //   "UKRAINE",
  //   "UNITED ARAB EMIRATES",
  //   "UNITED KINGDOM",
  //   "URUGUAY",
  //   "UZBEKISTAN",
  //   "VANUATU",
  //   "VATICAN CITY",
  //   "VENEZUELA",
  //   "VIETNAM",
  //   "YEMEN",
  //   "ZAMBIA",
  //   "ZIMBABWE",
  // ],

  state: [
    "ALABAMA",
    "ALASKA",
    // "AMERICAN SAMOA",
    "ARIZONA",
    "ARKANSAS",
    "CALIFORNIA",
    "COLORADO",
    "CONNECTICUT",
    "DELAWARE",
    "DISTRICT OF COLUMBIA",
    // "FEDERATED STATES OF MICRONESIA",
    "FLORIDA",
    "GEORGIA",
    "GUAM",
    "HAWAII",
    "IDAHO",
    "ILLINOIS",
    "INDIANA",
    "IOWA",
    "KANSAS",
    "KENTUCKY",
    "LOUISIANA",
    "MAINE",
    // "MARSHALL ISLANDS",
    "MARYLAND",
    "MASSACHUSETTS",
    "MICHIGAN",
    "MINNESOTA",
    "MISSISSIPPI",
    "MISSOURI",
    "MONTANA",
    "NEBRASKA",
    "NEVADA",
    "NEW HAMPSHIRE",
    "NEW JERSEY",
    "NEW MEXICO",
    "NEW YORK",
    "NORTH CAROLINA",
    "NORTH DAKOTA",
    "NORTHERN MARIANA ISLANDS",
    "OHIO",
    "OKLAHOMA",
    "OREGON",
    //"PALAU",
    "PENNSYLVANIA",
    "PUERTO RICO",
    "RHODE ISLAND",
    "SOUTH CAROLINA",
    "SOUTH DAKOTA",
    "TENNESSEE",
    "TEXAS",
    "UTAH",
    "VERMONT",
    "VIRGIN ISLANDS",
    "VIRGINIA",
    "WASHINGTON",
    "WEST VIRGINIA",
    "WISCONSIN",
    "WYOMING",
  ],
  abbreviatedState: [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VI",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ],
  classofAdmission: [
    "N/A",
    "A1/A2",
    "A-3",
    "B-1",
    "B-2",
    "C-1",
    "CW-1",
    "E-1",
    "E-2",
    "E-3",
    "EWI",
    "F-1",
    "F-2",
    "G-1",
    "G-4",
    "G-5",
    "H-1A",
    "H-1B",
    "H-1B1",
    "H-2A",
    "H-2B",
    "H-3",
    "H-4",
    "I",
    "J-1",
    "J-2",
    "L-1",
    "L-2",
    "M-1",
    "M-2",
    "N",
    "Not in USA",
    "O-1",
    "O-2",
    "O-3",
    "P-1",
    "P-3",
    "Parolee",
    "Q",
    "R-1",
    "R-2",
    "T-2",
    "TD",
    "TN",
    "TPS",
    "VWT",
  ],
};
